import { render } from "./SidebarSakuhin.vue?vue&type=template&id=f98ad9f2&scoped=true"
import script from "./SidebarSakuhin.vue?vue&type=script&lang=js"
export * from "./SidebarSakuhin.vue?vue&type=script&lang=js"

import "./SidebarSakuhin.vue?vue&type=style&index=0&id=f98ad9f2&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f98ad9f2"]])

export default __exports__